import Button from 'components/_UI/Button';
import Ilustration from 'components/_UI/Ilustration';
import Loader from 'components/_UI/Loader';
import Text from 'components/_UI/Text';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import React, { useEffect, useState } from 'react'
import { Edit, Gift, Home, Link, Mail, Plus, PlusSquare, Trash2, Crosshair, Award } from 'react-feather';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import { Row } from 'styled/alignment/Row';
import { useEvent } from 'context/events/Event';
import CustomFieldsForm from './CustomFieldsForm';
import customFieldsApi from 'api/requests/customFields';
import CustomFieldCard from './CustomFieldCard';
import CustomFieldsDeleteModal from './CustomFieldsDeleteModal';
import fonts from 'theme/fonts';
import { BlockContent } from 'styled/UI/BlockContent';
import CreateDrawer from './drawer/CreateDrawer';
import randomPickerApi from 'api/requests/randomPicker';
import ListDrawer from './drawer/ListDrawer';
import { useRef } from 'react'
import DetailDrawer from './drawer/DetailDrawer';
import Paginate from 'components/_UI/Paginate';
import Modal from 'components/_UI/Modal';
import FaqForm from './faq/FaqForm';
import { set } from 'react-hook-form';
import faqApi from 'api/requests/faq';
import FaqList from './faq/FaqList';
import pixelsApi from 'api/requests/pixels';
import PixelForm from './pixels/PixelForm';
import PixelCard from './pixels/PixelCard';
import PixelDeleteModal from './pixels/PixelDeleteModal';
import certificateApi from 'api/requests/certificate';
import CertificateForm from './certificate/CertificateForm';



export default function Additional() {
    const { toast, toasts } = useToast();
    const { event } = useEvent();

    const [loadingFields, setLoadingFields] = useState(false);
    const [loadingGiveaways, setLoadingGiveaways] = useState(false);
    const [loadingFaq, setLoadingFaq] = useState(false);
    const [loadingPixels, setLoadingPixels] = useState(false);
    const [content, setContent] = useState();
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisibleDrawer, setModalVisibleDrawer] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [edit, setEdit] = useState(false);
    const [giveaways, setGiveaways] = useState([]);
    const [refresh, setRefresh] = useState(false)
    const [perPage, setPergage] = useState(0)
    const [lastPage, setLastPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [firstPage, setFirstPage] = useState(0)
    const [modalDetailDrawer, setModalDetailDrawer] = useState(false)
    const [modalFaq, setModalFaq] = useState(false)
    const [faq, setFaq] = useState([])
    const [pixels, setPixels] = useState([])
    const [modalPixel, setModalPixel] = useState(false)
    const [deletePixelModal, setDeletePixelModal] = useState(false)
    const [loadingCertificate, setLoadingCertificate] = useState(false)
    const [certificate, setCertificate] = useState(null)
    const [modalCertificate, setModalCertificate] = useState(false)

    useEffect(() => {
        getCustomFields();
        getGiveaways();
        getFaq();
        getPixels();
        getCertificate();
    }, [refresh])

    const ref = useRef(null)

    function refreshData() {
        setModalVisible(false);
        setDeleteModal(false);
        setEdit(false);

        getCustomFields();
        getGiveaways();
        getFaq();
        getPixels();
        getCertificate();
    }

    async function getCertificate() {
        setLoadingCertificate(true)
        try {
            const { data } = await certificateApi.get(event?.slug)
            setCertificate(data?.data || null)
        } catch (error) {
        } finally {
            setLoadingCertificate(false)
        }
    }

    async function getCustomFields() {
        setLoadingFields(true);

        try {
            const { data } = await customFieldsApi.get(event?.slug);
            setContent(data?.data);

        } catch (error) {

        } finally {
            setLoadingFields(false);
        }
    }

    async function getFaq() {
        setLoadingFaq(true);

        try {
            const {data} = await faqApi.get(event?.slug)
            setFaq(data?.data)

        } catch (error) {

        } finally {
            setLoadingFaq(false);
        }
    }

    async function getPixels() {
        setLoadingPixels(true);
        try {
            const { data } = await pixelsApi.get(event?.slug)
            setPixels(data?.data || [])
        } catch (error) {
        } finally {
            setLoadingPixels(false);
        }
    }

    async function getGiveaways(number = 1) {
        setLoadingGiveaways(true);

        try {
            const { data } = await randomPickerApi.get(event?.slug, number);

            setGiveaways(data?.data)
            setPergage(data?.meta?.per_page)
            setFirstPage(data?.meta?.first_page)
            setLastPage(data?.meta?.last_page)
            setCurrentPage(data?.meta?.current_page)
            setTotalItems(data?.meta?.total)

        } catch (error) {

        } finally {
            setLoadingGiveaways(false);
        }
    }

    async function deleteGiveaway(id) {

        setLoadingGiveaways(true)

        try {
            await randomPickerApi.delete(event?.slug, id);
            handleSuccess()
        } catch (error) {
        } finally {
            setLoadingGiveaways(false)
        }
    }

    async function deleteFaq(id) {
        setLoadingFaq(true)

        try {
            await faqApi.delete(event?.slug, id)
            handleSuccess()
        } catch (error) {

        } finally {
            setLoadingFaq(false)
        }
    }

    function handleSuccess(item) {
        
        setRefresh(!refresh)
        setModalVisibleDrawer(false);
        setModalDetailDrawer(false)
        setModalFaq(false)
        if(modalDetailDrawer.type === 'deleteDrawer') {
            toast.success('Sorteio excluído com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'createFaq') {
            toast.success('Pergunta criada com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'editFaq') {
            toast.success('Pergunta editada com sucesso!', {
                position: 'top-center'
            })
        }

        if(modalFaq?.type === 'deleteFaq') {
              toast.success('Pergunta excluída com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'createPixel') {
            setModalPixel(false)
            toast.success('Pixel criado com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'editPixel') {
            setModalPixel(false)
            toast.success('Pixel atualizado com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'deletePixel') {
            setDeletePixelModal(false)
            toast.success('Pixel excluído com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'createCertificate') {
            setModalCertificate(false)
            toast.success('Certificado criado com sucesso!', {
                position: 'top-center'
            })
        }

        if(item === 'editCertificate') {
            setModalCertificate(false)
            toast.success('Certificado atualizado com sucesso!', {
                position: 'top-center'
            })
        }

    }

    

    function toggleModalAction(action) {
       
        if (!content?.length && action === 'fieldAdditional') {
            setModalVisible(true)
            return
        }

        if(action === 'drawer') {
            setModalVisibleDrawer(true)
            return
        }

        if(action.type === 'detailDrawer') {
            setModalDetailDrawer(action)
            return
        }

        if(action.type === 'deleteDrawer') {
            setModalDetailDrawer(action)
            return
        }

        if(action?.type === 'faq' || action?.type === 'editFaq' ) {
            setModalFaq(action)
            return

        }

        if(action.type === 'deleteFaq') {
            setModalFaq(action)
            return
        }

        if(action.type === 'editFaq') {
            setModalFaq(action)
            return
        }

        if(action === 'pixel') {
            setModalPixel(true)
            return
        }

        if(action?.type === 'editPixel') {
            setModalPixel(action)
            return
        }

        if(action?.type === 'deletePixel') {
            setDeletePixelModal(action)
            return
        }

        if(action === 'certificate') {
            setModalCertificate(true)
            return
        }

        if(action?.type === 'editCertificate') {
            setModalCertificate(action)
            return
        }

        if(content?.length && action === 'fieldAdditional') {
            setEdit(content);
            setModalVisible(true);
        }
    }



    return (
        <Container>
            <ToastContainer toasts={toasts} />

            <HeaderContent>
                <Column width='auto'>
                    <Text name='subtitle' color={colors.nightDark}>
                        Configurações adicionais
                    </Text>
                    <Text marginBottom={'10px'} paddingBottom={0}>
                        Personalize e estenda as funcionalidades do seu evento.
                    </Text>
                </Column>

                {/* {
                    !content?.length && (
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => setModalVisible(true)}
                        >
                            <PlusSquare color={colors.neutralLight} size={16} />
                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Criar campos personalizados
                            </Text>
                        </Button>
                    )
                } */}
            </HeaderContent>

            <BlockContent>
                <ContentHeader>
                    <Column>
                        <Row>
                            <Plus color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Campos personalizados</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                            Colete informações extras dos participantes durante a inscrição.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction('fieldAdditional')}
                        >
                            {content?.length
                                ? <Edit color={colors.neutralLight} size={16} />
                                : <PlusSquare color={colors.neutralLight} size={16} />
                            }

                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                {content?.length ? 'Editar formulário' : 'Adicionar campos'}
                            </Text>
                        </Button>

                        <DeleteContainer onClick={() => setDeleteModal(true)}>
                            <Trash2
                                size={16}
                                color={colors.danger}
                            />
                        </DeleteContainer>
                    </ButtonsContainer>
                </ContentHeader>

                {
                    loadingFields ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        <ContainerAdditionalFields>
                            {
                                !content?.length ? (
                                    <ContentCardEmpty>
                                        <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                            Nenhum campo personalizado criado ainda.
                                        </Text>
                                    </ContentCardEmpty>
                                ) : (
                                    <CustomFieldsContainer>
                                        {content?.map(el => (
                                            <CustomFieldCard data={el} key={el?.id} />
                                        ))}
                                    </CustomFieldsContainer>
                                )
                            }
                        </ContainerAdditionalFields>

                    )


                }
            </BlockContent>


             <BlockContent>
        

                <ContentHeader>
                    <Column>
                        <Row>
                             <Gift color={colors.secondaryPurple} size={22} />
                                <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Sorteador</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                           Faça sorteios e distribua prêmios entre os participantes do seu evento.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction('drawer')}
                        >
                            <Gift color={colors.neutralLight} size={16} />

                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Sortear Paricipantes
                            </Text>
                        </Button>
                    </ButtonsContainer>
                </ContentHeader>

                 {
                    loadingGiveaways ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        (!giveaways?.length || giveaways[0]?.winners?.length === 0) ? (
                            <ContentCardEmpty>
                                <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                    Nenhum sorteio criado.
                                </Text>
                            </ContentCardEmpty>
                        ) : (
                            <>
                                {giveaways?.map(el => (
                                    <ListDrawer
                                        key={el.id}
                                        giveaway={el}
                                        isLoading={loadingGiveaways}
                                        toggleAction={toggleModalAction}
                                    />
                                ))}
                                {lastPage > 1 && (
                                    <Paginate
                                    perPage={perPage}
                                    totalItems={totalItems}
                                    lastPage={lastPage}
                                    firstPage={firstPage}
                                    currentPage={currentPage}
                                    marginTop={'20px'}
                                    onPaginate={(number) => getGiveaways(number)}
                                />
                                )}
                            </>
                        )

                    )
                }
            </BlockContent>
            
            <BlockContent>
                <ContentHeader>
                    <Column>
                        <Row style={{ 'justifyContent': 'space-between' }}>
                            <Row width='auto'>
                                <Mail color={colors.secondaryPurple} size={22} />
                                <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>FAQ do evento</Text>
                            </Row>
                        
                        </Row>

                        <Text marginTop={'10px'} paddingBottom={0}>
                            Crie uma seção de Perguntas Frequentes para ajudar seus participantes.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction({type: 'faq'})}
                        >
                            <PlusSquare color={colors.neutralLight} size={16} />
                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Adicionar pergunta
                            </Text>
                        </Button>
                    </ButtonsContainer>
                </ContentHeader>

                <Column>
                    {loadingFaq ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        faq?.length > 0 ? (
                            <>
                                <Text marginTop={'10px'} color={colors.nightDark} type='bold'>Perguntas frequentes ({faq?.length})</Text>
                                <FaqList
                                    faq={faq}
                                    action={toggleModalAction}
                                 />
                            </>
                        ) : (
                             <ContentCardEmpty margin>
                                <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                    Nenhuma pergunta criada ainda.
                                </Text>
                            </ContentCardEmpty>
                        )
                    )
                    }

                </Column>
                
            </BlockContent>

            <BlockContent>
                <ContentHeader>
                    <Column>
                        <Row>
                            <Crosshair color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Pixels de rastreamento</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                            Adicione pixels de rastreamento para monitorar conversões e otimizar campanhas.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => toggleModalAction('pixel')}
                        >
                            <PlusSquare color={colors.neutralLight} size={16} />
                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                Adicionar pixel
                            </Text>
                        </Button>
                    </ButtonsContainer>
                </ContentHeader>

                <PixelsContainer>
                    {loadingPixels ? (
                        <ContentLoader>
                            <Loader />
                        </ContentLoader>
                    ) : (
                        pixels?.length > 0 ? (
                            pixels.map(pixel => (
                                <PixelCard
                                    key={pixel.id}
                                    data={pixel}
                                    onEdit={() => toggleModalAction({ type: 'editPixel', item: pixel })}
                                    onDelete={() => toggleModalAction({ type: 'deletePixel', item: pixel })}
                                />
                            ))
                        ) : (
                            <ContentCardEmpty>
                                <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                    Nenhum pixel de rastreamento adicionado ainda.
                                </Text>
                            </ContentCardEmpty>
                        )
                    )}
                </PixelsContainer>
            </BlockContent>


            <BlockContent>
                <ContentHeader>
                    <Column>
                        <Row>
                            <Award color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>Geração de certificados</Text>
                        </Row>
                        <Text marginTop={'10px'} paddingBottom={0}>
                            Crie e personalize certificados para os participantes do seu evento.
                        </Text>
                    </Column>

                    <ButtonsContainer>
                        <Button
                            variant='featured'
                            category='squired'
                            onClick={() => {
                                if (certificate) {
                                    toggleModalAction({ type: 'editCertificate', item: certificate })
                                } else {
                                    toggleModalAction('certificate')
                                }
                            }}
                        >
                            {certificate
                                ? <Edit color={colors.neutralLight} size={16} />
                                : <PlusSquare color={colors.neutralLight} size={16} />
                            }
                            <Text
                                color={colors.neutralLight}
                                paddingBottom={0}
                                marginLeft={'6px'}
                            >
                                {certificate ? 'Editar certificado' : 'Configurar certificado'}
                            </Text>
                        </Button>
                    </ButtonsContainer>
                </ContentHeader>

                {loadingCertificate ? (
                    <ContentLoader>
                        <Loader />
                    </ContentLoader>
                ) : (
                    !certificate ? (
                        <ContentCardEmpty margin>
                            <Text type='italic' color={colors.night} textAlign={'center'} paddingBottom={0}>
                                Nenhum certificado configurado ainda.
                            </Text>
                        </ContentCardEmpty>
                    ) : (
                        <CertificateStatus>
                            <Text name='small' color={colors.success} type='bold' paddingBottom={0}>
                                Certificado configurado
                            </Text>
                        </CertificateStatus>
                    )
                )}
            </BlockContent>

           

            <BlockContent>
                <Column>
                    <Row style={{ 'justifyContent': 'space-between' }}>
                        <Row width='auto'>
                            <Home color={colors.secondaryPurple} size={22} />
                            <Text name='highlight' marginLeft={'8px'} paddingBottom={0} color={colors.nightDark}>características do local</Text>
                        </Row>
                        <Tip>Em breve</Tip>
                    </Row>

                    <Text marginTop={'10px'} paddingBottom={0}>
                        Destaque as características e comodidades do local, como climatização, espaços instagramáveis e outros diferenciais para o público.
                    </Text>
                </Column>
            </BlockContent>

            {
                modalVisible &&
                <CustomFieldsForm
                    visible={modalVisible}
                    isEdit={edit}
                    toast={toast}
                    onClose={() => {
                        setEdit(false);
                        setModalVisible(false);
                    }}
                    onSuccess={refreshData}
                />
            }


            {
                modalVisibleDrawer && (
                    <CreateDrawer
                        visible={modalVisibleDrawer}
                        slug={event?.slug}
                        onSuccess={() => handleSuccess()}
                        onClose={() => {
                            setModalVisibleDrawer(false);
                        }}
                    />
                )
            }
            {
                modalDetailDrawer?.type == 'detailDrawer' ? (
                    <DetailDrawer
                        modalDetailDrawer={modalDetailDrawer}
                        setModalDetailDrawer={setModalDetailDrawer}
                     />
                ) : (
                    modalDetailDrawer?.type == 'deleteDrawer' && (
                        <Modal isOpen={modalDetailDrawer?.type == 'deleteDrawer'} onClose={() => setModalDetailDrawer(false)}>
                            <Text>Tem certeza que deseja excluir esse sorteio?</Text>

                            {loadingGiveaways ? (
                                <Loader />
                            ) : (
                                <ContentAction>
                                    <Button onClick={() => setModalDetailDrawer(false)} variant='light'>Cancelar</Button>
                                    <Button onClick={() => deleteGiveaway(modalDetailDrawer?.item?.giveaway?.id)}>Confirmar</Button>
                                </ContentAction>
                            )}
                            
                        </Modal>
                    ) 
                )
            }

            {
                modalFaq?.type === 'deleteFaq' && (
                    <Modal isOpen={modalFaq?.type == 'deleteFaq'} onClose={() => setModalFaq(false)}>
                         <Text>Tem certeza que deseja excluir esse pergunta?</Text>
                            {loadingFaq ? (
                                <Loader />
                            ) : (
                                <ContentAction>
                                    <Button onClick={() => setModalFaq(false)} variant='light'>Cancelar</Button>
                                    <Button onClick={() => deleteFaq(modalFaq?.item?.id)}>Confirmar</Button>
                                </ContentAction>
                            )}
                    </Modal>
                ) 
            }

            {
                (modalFaq?.type == 'faq' || modalFaq?.type == 'editFaq') && (
                    <FaqForm 
                        modalFaq={modalFaq}
                        edit={modalFaq?.item}
                        setModalFaq={setModalFaq}
                        onSuccess={handleSuccess}
                    />
                )

            }

            {
                deleteModal &&
                <CustomFieldsDeleteModal
                    visible={deleteModal}
                    toast={toast}
                    onClose={() => setDeleteModal(false)}
                    onSuccess={refreshData}
                />
            }

            {
                modalPixel && (
                    <PixelForm
                        visible={modalPixel}
                        setVisible={setModalPixel}
                        edit={modalPixel?.item || false}
                        onSuccess={handleSuccess}
                    />
                )
            }

            {
                deletePixelModal?.type === 'deletePixel' && (
                    <PixelDeleteModal
                        visible={!!deletePixelModal}
                        data={deletePixelModal?.item}
                        onClose={() => setDeletePixelModal(false)}
                        onSuccess={handleSuccess}
                    />
                )
            }

            {
                modalCertificate && (
                    <CertificateForm
                        visible={!!modalCertificate}
                        setVisible={setModalCertificate}
                        edit={modalCertificate?.item || false}
                        onSuccess={handleSuccess}
                    />
                )
            }

        </Container >
    )
}


const Container = styled(Column)`
    width: 100%;
`;

const HeaderContent = styled(Column)`
    width: 100%;
    padding: 14px 0;
    
    & > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
        & > h2,
        & > button {
            width: auto;
            margin-top: 0;
        }
        
        
    }
`;

const CustomFieldsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px; 
  width: 100%;

  > div {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.lg}) {
    > div {
      /* flex: 0 0 calc((100% - 24px) / 3); // 3 itens, considerando 2 gaps de 24px */
      width: 31.5%;
    }
  }
`;


const Picture = styled.picture`
    width: auto;
    height: 300px;
`;

const ActionButton = styled.div`
    width: auto;
    height: auto;
    transition: all ease-in-out .25s;
    cursor: pointer;

    ${({ disabled }) => disabled && `
        opacity: .4;
        pointer-events: none;
    `};
`;

const DiscountCodesList = styled(Column)`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  > div {
    flex: 1 1 calc(33.33% - 16px);
    min-width: 280px;
  }

  @media screen and (max-width: ${breakpoints.lg}) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
`;


const ContentLoader = styled(Column)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentCardEmpty = styled.div`
    border: 1px solid ${colors.nightLight};
    background-color: #eee;
    border-radius: 8px;
    padding: 30px 20px;
    width: 100%;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 33.5%;
    }

    ${({margin}) => margin && `
        margin-top: 10px;
    `}
`;

const ContentHeader = styled(Column)`
    & > div > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        & > div > button {
            margin-top: 0;
            width: 245px;
        }

    }
`;

const ContainerAdditionalFields = styled(Row)`
    margin-top: 14px;
    width: 100%;
    flex-wrap: wrap;
`;

const DeleteContainer = styled(FullyCentered)`
    width: auto;
    height: auto;
    /* padding: 10px; */
    border: 1px solid ${colors.danger};
    border-radius: 8px;
    margin-left: 8px;
    cursor: pointer;
    padding: 10px;

    @media screen and (min-width: ${breakpoints.lg}) {
        margin-bottom: 10px;
    }

`;

const ButtonsContainer = styled(Row)`
    height: auto;
    width: auto;
    align-items: center;
    margin-top: 6px;
`;

const Tip = styled.div`
    background-color: #F3E8FF;
    color: ${colors.secondaryPurple};
    font-size: ${fonts.sizes.small};
    padding: 4px 12px;
    font-weight: bold;
    border-radius: 30px;
`;

const ContentAction = styled(Column)`

    margin-top: 15px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;
        gap: 5px;
    }
`;

const PixelsContainer = styled(Row)`
    margin-top: 14px;
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
`;

const CertificateStatus = styled.div`
    margin-top: 14px;
    padding: 12px 16px;
    background-color: #E8F5E9;
    border-radius: 8px;
    width: fit-content;
`;


    
